import React from 'react'
import { Card, Icon, Button } from 'semantic-ui-react'
import ButtonAction from './Button'

function computeButtons(buttons) {
  return (
    <Button.Group fluid>
      {
        buttons.map((button, i) => {
          console.log("button", button);
          return (
          <ButtonAction
            button={button.data}
            key={i}
          />
        )}
        )
      }
    </Button.Group>
  )
}

const header = title => (
  <h3>
    <Icon circular inverted color='blabla' size="small" name="info" />
    {title}
  </h3>
)

const InfoMessage = ({ message }) => {
  console.log("InfoMessage", message);
  const {
    title,
    description = '',
    buttons = null,
  } = message

  return (
    <Card
      header={header(title)}
      description={description.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)}
      extra={buttons && computeButtons(buttons)}
    />
  )
}

export default InfoMessage



// WEBPACK FOOTER //
// ./src/views/components/InfoMessage.js